// The Captain's Club — Anchor Management's private membership circle.

export const MEMBERSHIP_TIERS = [
  {
    id: "mariner",
    name: "Mariner",
    annualFee: 500,
    tagline: "An introduction to the Club.",
    perks: [
      "5% off all charters, year-round",
      "Priority email booking",
      "Welcome cocktail on your first sail",
      "Member newsletter with seasonal picks",
    ],
    accent: "sand",
  },
  {
    id: "captain",
    name: "Captain",
    annualFee: 1500,
    tagline: "For those who charter often and well.",
    featured: true,
    perks: [
      "10% off all charters",
      "Priority booking on peak dates",
      "One complimentary cocktail-tasting add-on per year",
      "Invite to one member-only sunset event per season",
      "$150 renewal credit toward your next charter",
    ],
    accent: "pink",
  },
  {
    id: "commodore",
    name: "Commodore",
    annualFee: 5000,
    tagline: "Unrestricted access. First in line, always.",
    perks: [
      "15% off all charters",
      "First-access to marquee dates: Non-Mariners, Cup Match, NYE, Newport Bermuda Race",
      "Complimentary bar & food add-ons up to $300 per charter",
      "Invitations to two private member events per season",
      "$500 renewal credit",
      "Annual thank-you gift, hand-delivered",
    ],
    accent: "navy",
  },
];

export const MEMBER_CAP = 60;
